/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */

import React from "react";
import NewLiveBlogStory from "./new";
import OldLiveBlogStory from "./old";
import PropTypes from "prop-types";
import get from "lodash/get";
import { useSelector } from "react-redux";
import StoryRowWrapper from "../story-row-wrapper.js";

export const LiveBlogStory = props => {
  const { config, storyStoreField, storyPageType } = props;
  const isPbEnabled = get(config, ["pagebuilder-config", "featureToggle", "liveBlogStoryPage"], false);
  if (isPbEnabled) {
    const storyRows = useSelector(state =>
      get(state, ["qt", "config", "pagebuilder-config", storyStoreField, storyPageType, "rows"], [])
    );
    return (
      <StoryRowWrapper rows={storyRows}>
        <NewLiveBlogStory {...props} />
      </StoryRowWrapper>
    );
  }
  return <OldLiveBlogStory {...props} />;
};

LiveBlogStory.propTypes = {
  config: PropTypes.object,
  storyStoreField: PropTypes.string,
  storyPageType: PropTypes.string
};

LiveBlogStory.defaultProps = {
  storyStoreField: "story",
  storyPageType: "liveBlog-story"
};

export default LiveBlogStory;
